// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

/**
 * Workspace name constants
 */
export const WORKSPACE_NAMES = {
  MOST_ACTIVE: 'Most Active Projects',
  ALL_PROJECTS: 'All Projects with Activities',
  KEY_PROJECTS: 'Key Projects'
} as const;

/**
 * Workspace description constants
 */
export const WORKSPACE_DESCRIPTIONS = {
  MOST_ACTIVE: 'Top 5 projects with the most contributors',
  ALL_PROJECTS: 'Top 10 projects with recent activity',
  KEY_PROJECTS: 'Manually curated key projects'
} as const;

/**
 * API configuration constants
 */
export const API_CONSTANTS = {
  SEARCH_MIN_LENGTH: 2,
  AUTOCOMPLETE_PAGE_SIZE: 10,
  DEFAULT_WORKSPACE_LIMIT: 5,
  METRIC_CHART_COLUMN_DELAY: 500,
  METRIC_CHART_DATA_DELAY: 2000,
  SUMMARY_TABLE_DELAY: 1000
} as const;

/**
 * Time range names for influence data
 */
export const TIME_RANGE_NAMES = {
  MONTHLY: 'monthly',
  LAST_24_MONTHS: 'last_24mo'
} as const;

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  NO_ORG_ID: 'No organization ID found',
  NO_SALESFORCE_ID: 'No salesforce account ID found for company',
  WORKSPACE_NOT_FOUND: 'Workspace not found',
  PROJECT_NOT_FOUND: 'Project not found',
  FAILED_TO_CREATE_WORKSPACE: 'Failed to create workspace',
  FAILED_TO_UPDATE_WORKSPACE: 'Failed to update workspace',
  FAILED_TO_ADD_PROJECTS: 'Failed to add projects to workspace',
  FAILED_TO_LOAD_MEMBERSHIP: 'Error loading membership details',
  COMPANY_ID_NOT_FOUND: 'Company account ID not found'
} as const;

